import type { CSSProperties, FC } from "react"

interface Props {
  className?: string
  style?: CSSProperties
}

const Location2: FC<Props> = ({ className, style }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M10.125 14.7202C10.2383 14.785 10.3666 14.8191 10.4972 14.8191C10.6277 14.8191 10.756 14.785 10.8694 14.7202C11.0991 14.588 16.4944 11.439 16.4944 5.81867C16.4472 4.25989 15.7951 2.7807 14.676 1.69454C13.5569 0.608386 12.059 0.000609922 10.4995 4.58806e-07C8.93997 -0.000609004 7.44151 0.605996 6.3216 1.69128C5.2017 2.77656 4.54835 4.25524 4.5 5.81398C4.5 11.439 9.89812 14.5834 10.125 14.7202ZM10.5 3.56398C10.945 3.56398 11.38 3.69594 11.75 3.94317C12.12 4.19041 12.4084 4.54181 12.5787 4.95294C12.749 5.36408 12.7936 5.81648 12.7068 6.25293C12.62 6.68939 12.4057 7.0903 12.091 7.40497C11.7763 7.71964 11.3754 7.93393 10.939 8.02075C10.5025 8.10756 10.0501 8.06301 9.63896 7.89271C9.22783 7.72241 8.87643 7.43402 8.62919 7.06401C8.38196 6.694 8.25 6.25899 8.25 5.81398C8.25 5.21724 8.48705 4.64495 8.90901 4.22299C9.33097 3.80103 9.90326 3.56398 10.5 3.56398ZM21 15.564C21 18.4871 15.5897 20.064 10.5 20.064C5.41031 20.064 0 18.4871 0 15.564C0 14.1962 1.23937 12.9849 3.49031 12.1543C3.67491 12.0933 3.87596 12.1064 4.0511 12.1908C4.22624 12.2751 4.36178 12.4242 4.42913 12.6066C4.49648 12.789 4.49039 12.9904 4.41215 13.1683C4.3339 13.3463 4.1896 13.4869 4.00969 13.5605C2.46187 14.1334 1.5 14.9002 1.5 15.564C1.5 16.8165 4.92375 18.564 10.5 18.564C16.0763 18.564 19.5 16.8165 19.5 15.564C19.5 14.9002 18.5381 14.1334 16.9903 13.5615C16.8104 13.4878 16.6661 13.3472 16.5879 13.1693C16.5096 12.9913 16.5035 12.7899 16.5709 12.6075C16.6382 12.4252 16.7738 12.2761 16.9489 12.1917C17.124 12.1073 17.3251 12.0942 17.5097 12.1552C19.7606 12.9849 21 14.1962 21 15.564Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Location2
